export enum ProfileMutationsTypeEnum {
  UPDATE_DATA = 'UPDATE_DATA',
  UPDATE_STATE = 'UPDATE_STATE',
}
